import { render, staticRenderFns } from "./FreeProducts.vue?vue&type=template&id=a2772498&scoped=true&"
import script from "./FreeProducts.vue?vue&type=script&lang=js&"
export * from "./FreeProducts.vue?vue&type=script&lang=js&"
import style0 from "./FreeProducts.vue?vue&type=style&index=0&id=a2772498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2772498",
  null
  
)

export default component.exports